import { render } from "./userCenter.vue?vue&type=template&id=1d623d37&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"

import "./userCenter.vue?vue&type=style&index=0&id=1d623d37&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d623d37"]])

export default __exports__